import React, { ReactElement, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { Button } from 'idsk-react-components';
import { ConfirmModal, useHistoryContext } from 'slovlex-idsk-react-components';
import Termin from '../../../model/Termin';
import { useClient, useClientStatusContext } from '../../../context/ClientStatusContext';
import { useSuccessMessageContext } from '../../../context/SuccessMessageContext';
import { deleteTermin } from '../../../client/termin/terminDeleteClient';
import routes from '../../../routing/routes';
import { technickePricinyErrorStatus } from '../../../constants/ErrorConstant';

interface Props {
  termin: Termin;
  openButtonText: string,
  // eslint-disable-next-line max-len
  buttonStyle?: 'action' | 'negative' | 'link' | 'secondary' | 'primary' | 'third' | 'warning' | 'link-negative' | 'link-black';
  buttonSize?: 'small' | 'large' | 'medium' | 'extra-small';
  reloadTerminPage?;
}

const TerminDeleteConfirmModal = ({
  termin,
  openButtonText,
  buttonStyle,
  buttonSize,
  reloadTerminPage,
}: Props): ReactElement => {
  const navigate = useNavigate();
  const { routeMap } = useHistoryContext();
  const { displaySuccess } = useSuccessMessageContext();
  const {
    wrapClient: deleteTerminClient,
    status: deleteTerminStatus,
  } = useClient(deleteTermin);
  const { tezaurusUuid } = useParams<{ tezaurusUuid: string }>();
  const { handleStatus } = useClientStatusContext();

  const handleDeleteTermin = async (): Promise<void> => {
    await deleteTerminClient(termin.uuid);
    if (reloadTerminPage) {
      reloadTerminPage();
    } else {
      const tezaurusListRoute = routes.tezaurus.admin.termin.list.withParams(tezaurusUuid);
      navigate(routeMap.get(tezaurusListRoute) ? routeMap.get(tezaurusListRoute) : tezaurusListRoute);
    }
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (deleteTerminStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [deleteTerminStatus, handleStatus]);

  return (
    <ConfirmModal
      question={`Naozaj si prajete zmazať termín "${termin.termin}"?`}
      cancelButtonText="Zrušiť"
      confirmButton={
        (
          <Button buttonStyle="negative" size="large">Zmazať</Button>
        )
      }
      openButton={(
        <Button buttonStyle={buttonStyle} size={buttonSize}>
          {openButtonText}
        </Button>
      )}
      doAfterConfirm={handleDeleteTermin}
    />
  );
};

export default TerminDeleteConfirmModal;
